export default __webpack_public_path__ + "static/fabric-profile-catalogue-fabric-view-17e61827ab8dc90782a8c0359a8c1047.png";